tenderView.controller('tenderViewComplaintAppealCtrl', function(
    $scope,
    $timeout,
    $state,
    ntFlash,
    $rootScope,
    data,
    complaintService,
    documentsService,
    $uibModalInstance
) {

    $scope.complain = data.complaint

    $scope.tenderId = data.tenderId
    $scope.awardId = data.awardId
    $scope.qualificationId = data.qualificationId
    $scope.cancellationId = data.cancellationId
    $scope.appealIsset = data.appeal
    $scope.minDateDeliveryStart = new Date($scope.complain.dateSubmitted)

    $scope.appeal = {
        description: '',
    }
    $scope.proceeding = {
        dateProceedings: '',
        proceedingNumber: ''
    }
    if(data.appeal){
      $scope.appeal.description = data.appeal.description
    }

    $scope.editDescription = true
    $scope.disablePublishBtn = false

    $scope.files = [];

    $scope.submit = function() {
        $scope.disablePublishBtn = true;

        function uploadToDocumentService(filesList) {
            return new Promise((resolve) => {
                if (filesList.length) {
                    $scope.showProgress = gettext('Завантажуються файли');
                    return documentsService.uploadToDocumentService(filesList)
                        .then((documents) => {
                            resolve(documents);
                        });
                }
                return resolve()
            })
        }

        uploadToDocumentService($scope.files)
            .then((documents) => {
                let requestData = {
                    description: $scope.appeal.description
                };
                if (documents) {
                    requestData.documents = documents;
                }
                $scope.showProgress = gettext('Створюється запис');
                return $scope.sign(requestData)
                    .then((result) =>{
                        return documentsService.uploadToDocumentService([result])
                            .then((documents) => {
                                if(requestData.documents){
                                  requestData.documents.push(documents[0])
                                } else {
                                    requestData.documents = documents
                                }
                                return requestData
                            })
                    })

            })
            .then((result) => {
                return complaintService.createAppeal($scope.tenderId, result, $scope.complain.id, $scope.complain.awardId, $scope.complain.qualificationId, $scope.complain.cancellationId)


            })
            .then((result) => {
                $uibModalInstance.close();
                $state.go('tenderView.complaint', {}, {
                        reload: true
                    });
            })
            .catch((error) => {
                ntFlash.error(gettext('Сталася помилка'));
                console.error('Error: ', error);
                $uibModalInstance.close();
            });

    };
    $scope.addDateProceedings = () =>{

        const data = {
            proceeding: $scope.proceeding
        }
        complaintService.updateAppeal($scope.tenderId, data, $scope.appealIsset.id, $scope.complain.id, $scope.complain.awardId, $scope.complain.qualificationId, $scope.complain.cancellationId)
            .then((result) => {
                $uibModalInstance.close();
                $state.go('tenderView.complaint', {}, {
                        reload: true
                    });
            })
            .catch((error) => {
                ntFlash.error(gettext('Сталася помилка'));
                console.error('Error: ', error);
                $uibModalInstance.close();
            });

    }


    $scope.close = function() {
        $uibModalInstance.close();
    };

    $scope.isDisabled = function() {
        return !$scope.appeal.description.length || $scope.disablePublishBtn;
    };

    $scope.deleteDoc = function(index) {
        $scope.files.splice(index, 1);
    };

    $scope.$watch('file', function(val) {
        if ($scope.file && $scope.file.length) {
            $scope.files = $scope.files.concat(val);
        }
    });

    $scope.sign = (complaint) => {
       return  documentsService.signData(complaint)
            .then(data =>  data)
            .catch(error => console.log('documentsService.sign error', error));
    };

    // proceedingNumber
})
